import React from "react";
import './privacypolicy.css';

function PrivacyPolicyET (){

    const openNewTab =(url)=>{
        window.open(url, '_blank')
    }
    return (
        <div style={{marginLeft:5, marginRight:5,}}>
                        
            <p style={{textAlign:'center', fontSize:28}}>VODAFONE FIJI</p>
            <p style={{textAlign:'center', fontSize:28}}>E-Ticketing</p>
            <p style={{textAlign:'center', fontSize:28}}><strong>Our Privacy Policy</strong></p>

            <div>
    <h3>
        Privacy Statement
    </h3>
    <p>
        Vodafone Fiji Ltd. respects your privacy and is determined to help you feel comfortable with the way your personal information given to us online is handled. By submitting information through this site, you agree that Vodafone Fiji Ltd. may use it in accordance with this Privacy Policy. We've attempted to write it as clearly as possible and should you have any questions about the information contained here, please feel free to email us at <a href="mailto:info@vodafone.com.fj">info@vodafone.com.fj</a>.
    </p>
</div>

<div>
    <h3>
        What type of visitor information do we collect?
    </h3>
    <p>
        Unless visitors voluntarily submit information via forms or email to Vodafone Fiji Ltd. through the site, we do not collect any personal information at all. We do, however, analyze our server logs and identify usage patterns regularly. This information helps us to better manage our content and organize information in a more logical way for our visitors thereby improving the user experience.
    </p>
</div>

<div>
    <h3>
        What do we do with the information we collect?
    </h3>
    <p>
        If personal information is voluntarily submitted through our site, we do use it to fulfill requests for marketing materials or other enquiries.
    </p>
    <p>
        We do not otherwise sell, rent, exchange or disclose our client lists or information about our website users, except to the limited extent necessary to protect the rights, property and safety of our commission, our clients, or others or to comply with applicable law or if we are acquired and client information or information about our website users is a transferred asset.
    </p>
</div>

<div>
    <h3>
        What choices do you have?
    </h3>
    <p>
        If you prefer to contact us by phone or mail, please see our contact information page.
    </p>
</div>

<div>
    <h3>
        3rd Party Sites
    </h3>
    <p>
        This privacy policy is applicable only to information you provide to us through this website. We are not responsible for the privacy practices of any third party sites that are linked to or from our site.
    </p>
</div>

<div>
    <h3>
        Notice
    </h3>
    <p>
        We reserve the right to change this privacy policy and in the event we do, we will post the revised privacy policy on our website. Our use of the information you provide shall be governed by the privacy policy that is effective at the time of receipt of such information. Once again, if you should have any further questions concerning this policy, please email us at <a href="mailto:info@vodafone.com.fj">info@vodafone.com.fj</a>.
    </p>
</div>

            
        </div>
    
    )
}

export default PrivacyPolicyET;